import { Box, Button, CircularProgress, Grid, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import axios from 'axios';
import { useGoKredytService } from '../utils/axios';

export default function LoanMatrix() {
  const goKredytService = useGoKredytService();

  const [file, setFile] = useState(null);
  const [downloading, setDownloading] = useState(false); // State for handling download loading
  const [uploading, setUploading] = useState(false); // State for handling upload loading

  const handleUploadMatrix = async () => {
    if (!file) {
      alert("Please select a file to upload!");
      return;
    }

    setUploading(true); // Set loading state to true
    const formData = new FormData();
    formData.append('file', file);

    try {
      await goKredytService.post(process.env.REACT_APP_GO_KREDYT_API_URL + '/admin/loan/excel', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
      alert('Matryca wprowadzona poprawnie');
    } catch (error) {
      console.error('Error uploading the file', error);
      alert('Failed to upload the file');
    } finally {
      setUploading(false); // Reset loading state
    }
  };

  const handleDownloadMatrix = async () => {
    setDownloading(true); // Set loading state to true
    try {
      const response = await goKredytService.get(process.env.REACT_APP_GO_KREDYT_API_URL + '/admin/loan/excel', {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'loan_params.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading the file', error);
    } finally {
      setDownloading(false);
    }
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <>
      <Typography variant="h2" style={{marginTop:'50px'}}>
        Matryca pożyczki
      </Typography>

      <Grid container spacing={2} justifyContent="center" alignItems="stretch">
        {/* Left Column: Download */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              padding: '20px',
              textAlign: 'center',
              border: '1px solid #ccc',
              borderRadius: '8px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%', // Ensure full height
            }}
          >
            <Typography variant="h6" gutterBottom>
              Pobierz matrycę Excel
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownloadMatrix}
              disabled={downloading} // Disable button when downloading
              fullWidth
            >
              {downloading ? <CircularProgress size={24} /> : 'Pobierz matrycę Excel'}
            </Button>
          </Box>
        </Grid>

        {/* Right Column: Upload */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              padding: '20px',
              textAlign: 'center',
              border: '1px solid #ccc',
              borderRadius: '8px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%', // Ensure full height
            }}
          >
            <Typography variant="h6" gutterBottom>
              Prześlij matrycę
            </Typography>
            <TextField
              type="file"
              inputProps={{ accept: ".xlsx" }}
              onChange={handleFileChange}
              fullWidth
              sx={{ marginBottom: '10px' }}
              disabled={uploading} // Disable file input when uploading
            />
            <Button
              variant="contained"
              color="secondary"
              onClick={handleUploadMatrix}
              disabled={!file || uploading} // Disable button when no file or uploading
              fullWidth
            >
              {uploading ? <CircularProgress size={24} /> : 'Prześlij'}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}
